import React from "react"
import TaskIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5";
import {FieldViewProps} from "../../../../render/view";

export default function FieldTaskType_View(props:FieldViewProps) {

    // return <TaskTypeValue field={this} value={model[this.fieldId]} className={className} params={params} />

    const value : string = props.model[props.field.fieldId]

    const size = _.get(props.options,'size', 13)

    const taskType = gd.session.taskTypes.get(value);
    if (!taskType) return false;

    return <TaskIcon taskType={gd.session.taskTypes.get(value)}
                     className={props.className}
                     size={size}
    />

}